import React, { useState, useEffect, useCallback } from 'react';
import { Toaster, toast } from 'sonner';
import LoginPage from './components/LoginPage';
import FunnelPage from './components/FunnelPage';
import './components/funnel.css';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/** Вся CRM продаж — это одна воронка. Разделов больше нет намеренно:
 *  всё, что после договора, живёт в производственном сервисе. */
export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem('authToken');
    if (!token) { setChecking(false); return; }
    try {
      const r = await fetch(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!r.ok) throw new Error('токен не принят');
      const me = await r.json();
      setUser(me);
      localStorage.setItem('authUser', JSON.stringify(me));
    } catch {
      // Токен мог протухнуть за неделю — молча просим войти заново.
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    setUser(null);
    toast.success('Вы вышли');
  };

  if (checking) {
    return <div className="flex h-screen items-center justify-center text-sm opacity-50">Загрузка…</div>;
  }

  return (
    <>
      <Toaster position="top-right" richColors />
      {user ? (
        <>
          {/* Узкая полоса вместо шапки производственного сервиса: здесь один
              раздел, и меню выбора разделов ни к чему. */}
          <div className="funnel-ui fn-topline flex items-center gap-3 px-6 py-2.5 text-[13px] leading-5">
            <span className="font-semibold tracking-tight">Alicor · Продажи</span>
            {/* Дорога назад в калькулятор. Из него в CRM кнопка есть, а
                обратно человек упирался в тупик: переходил по кнопке и
                оставался тут, не зная, как вернуться к расчёту. Вкладка у
                менеджера одна — значит и дверь должна быть в обе стороны. */}
            <a href="https://al-spa.pl" className="opacity-[.75] hover:opacity-100">
              ← В калькулятор
            </a>
            <span className="ml-auto opacity-[.75]">{user.username}</span>
            <button type="button" onClick={logout} className="opacity-[.75] hover:opacity-100">
              Выйти
            </button>
          </div>
          <FunnelPage user={user} onLogout={logout} />
        </>
      ) : (
        <LoginPage onLogin={check} />
      )}
    </>
  );
}
